module.exports = " <div class=Task transition=Task- v-for=\"section in sections\" v-show=\"$index > 0\"> <h3 class=Task-headline>Current Task</h3> <div class=Task-text>{{{section.task}}}</div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Task.vue
// module id = 126
// module chunks = 2